import { SET_VISIBLE_POPUP, SET_SELECTED_POPUP, SET_SELECTED_TOOL } from '../constants/popupConstants';

const popupReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_VISIBLE_POPUP:
            return {
                ...state,
                isVisible: action.isVisible
            }
        case SET_SELECTED_POPUP:
            return {
                ...state,
                selectedPopup: action.selectedPopup
            }
        case SET_SELECTED_TOOL:
            return {
                ...state,
                selectedTool: action.selectedTool
            }
        case 'SHOW_POPUP':
            return {
                ...state,
                selectedPopup: action.selectedPopup,
                isVisible: true,
            }


        default:
            return { ...state };
    }
};

export default popupReducer;